// source: https://github.com/montalvomiguelo/hydrogen-theme/blob/main/frontend/lib/revive.js

export function media({query}) {
	const mediaQuery = window.matchMedia(query);
	return new Promise(function (resolve) {
		if (mediaQuery.matches) {
			resolve(true);
		} else {
			mediaQuery.addEventListener('change', resolve, {once: true});
		}
	});
}

export function visible({element}) {
	return new Promise(function (resolve) {
		const observer = new window.IntersectionObserver(async function (entries) {
			for (const entry of entries) {
				if (entry.isIntersecting) {
					observer.disconnect();
					resolve(true);
					break;
				}
			}
		});
		observer.observe(element);
	});
}

export function idle() {
	return new Promise(function (resolve) {
		if ('requestIdleCallback' in window) {
			window.requestIdleCallback(resolve);
		} else {
			setTimeout(resolve, 200);
		}
	});
}

export function revive(island, islands, isClass = false) {
	async function dfs(node, isClass) {
		if (node.hasAttribute('client:visible')) {
			await visible({element: node});
		}

		const clientMedia = node.getAttribute('client:media');
		if (clientMedia) {
			await media({query: clientMedia});
		}

		if (node.hasAttribute('client:idle')) {
			await idle();
		}
		if (isClass) {
			await islands[island]().then((Class) => new Class.default(node));
		} else {
			islands[island]();
			node.setAttribute('data-ready', true);
		}
	}

	const splitPath = island.split('/');
	const tagName = pascalToKebab(
		splitPath[splitPath.length - 1].replace('.js', ''),
	);
	const selector = isClass ? `[data-component=${tagName}]` : tagName;
	for (let node of Array.from(document.querySelectorAll(selector))) {
		dfs(node, isClass);
	}
}

function pascalToKebab(str) {
	return str
		.replace(/[A-Z]/g, (match) => `-${match.toLowerCase()}`)
		.replace(/^-/, '');
}
